<mat-card appearance="outlined" [ngClass]="{ hideCard: noCard }">
  <div *ngIf="(title || !hideSearch) && !newHeader" class="table-header">
    <h2>{{title}}</h2>
    <div *ngIf="!hideSearch" class="search">
      <mat-form-field *ngIf="searchColumns.length > 1 && !searchAll">
        <mat-select (selectionChange)="searchValue = ''; page()" [(ngModel)]="searchColumn"
                    placeholder="{{'general.searchColumn' | translate}}">
          <mat-option *ngFor="let column of searchColumns" [value]="column.prop">
            <ng-container *ngIf="!column.translationString && column.name">{{column.name}}</ng-container>
            <ng-container *ngIf="!column.translationString && !column.name">{{column.prop}}</ng-container>
            <ng-container *ngIf="column.translationString">{{column.translationString | translate}}</ng-container>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input (keyup)="onSearchChange()" [(ngModel)]="searchValue" matInput placeholder="{{'general.search' | translate}}">
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="newHeader && (title || showAdd || !hideSearch)" class="table-header-new">
    <div class="left">
      <div class="title" [innerHtml]="title || '&nbsp'"></div>
    </div>
    <div class="right">
      <div *ngIf="!hideSearch" class="search">
        <mat-form-field *ngIf="searchColumns.length > 1 && !searchAll">
          <mat-select (selectionChange)="searchValue = ''; page()" [(ngModel)]="searchColumn"
                      placeholder="{{'general.searchColumn' | translate}}">
            <mat-option *ngFor="let column of searchColumns" [value]="column.prop">
              <ng-container *ngIf="!column.translationString && column.name">{{column.name}}</ng-container>
              <ng-container *ngIf="!column.translationString && !column.name">{{column.prop}}</ng-container>
              <ng-container *ngIf="column.translationString">{{column.translationString | translate}}</ng-container>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <input (keyup)="onSearchChange()" [(ngModel)]="searchValue" matInput placeholder="{{'general.search' | translate}}">
        </mat-form-field>
      </div>
      <div class="buttons" *ngIf="headerButtons">
        <button *ngFor="let button of headerButtons" [disabled]="button?.disabled" mat-mini-fab (click)="executeHeaderButton(button)" [matTooltip]="button.tooltipTranslation | translate"><mat-icon>{{button.icon}}</mat-icon></button>
      </div>
    </div>
  </div>

  <div class="action-header" *ngIf="checkBoxActions" [ngClass]="{ active: !!selectedItems?.length }">
    <div
      class="count">{{ selectedItems?.length }} {{ 'general.selectedEntries' + (selectedItems.length > 1 ? 'Multi' : 'Single') | translate }}
    </div>
    <mat-form-field>
      <mat-select [placeholder]="'general.selectionActions' | translate">
        <mat-option (click)="executeSelectedAction(action)" *ngFor="let action of checkBoxActions">
          <mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon>
          {{action.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="actions"><mat-icon (click)="unselectAll()">close</mat-icon></div>
  </div>

  <div class="table-container">
    <div *ngIf="total > 0 && !noHeader" class="row header">
      <div class="column checkbox" *ngIf="checkBoxActions"><input (click)="selectAll($event)" type="checkbox"></div>
      <div class="column checkbox" *ngIf="showCheck"><input (click)="checkAll($event)" type="checkbox"></div>
      <div ripple (click)="changeOrder(column)" *ngFor="let column of columns" class="column {{'cw-' + columns?.length}}">
        <ng-container *ngIf="!column.translationString && column.name">{{column.name}}</ng-container>
        <ng-container *ngIf="!column.translationString && !column.name">{{column.prop}}</ng-container>
        <ng-container *ngIf="column.translationString">{{column.translationString | translate}}</ng-container>
        <mat-icon [class.down]="column.sorted < 0" class="single" *ngIf="column.sorted">{{column.sorted > 0 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
        <div class="up-down" *ngIf="!column.sorted"><mat-icon>keyboard_arrow_up</mat-icon><mat-icon>keyboard_arrow_down</mat-icon></div>
      </div>
      <div class="column actions  {{'width-' + getActionWidth()}}"></div>
    </div>
    <div class="row" *ngIf="rows.length === 0">
      <p>{{noDataMessage | translate}}</p>
    </div>
    <div class="row" *ngFor="let row of rows; let index = index" (click)="onClick(skip + index, row, $event)">
      <mat-chip-listbox *ngIf="!!lastActiveChip">
        <mat-chip-option [ngClass]="{ 'live': checkLastActive(row), 'disabled': !checkLastActive(row) }">-</mat-chip-option>
      </mat-chip-listbox>
      <div class="column checkbox" *ngIf="checkBoxActions"><input (click)="selectItem(row)" type="checkbox" [checked]="isChecked(row)"></div>
      <div class="column checkbox" *ngIf="showCheck"><input (click)="onCheck(skip + index, row, $event)"  type="checkbox" class="check-checkbox" id="check-checkbox-{{skip + index}}" [checked]="checkedIdList.includes(skip + index)"></div>
      <div *ngFor="let column of columns" class="column {{'cw-' + columns?.length}}" matTooltip="{{!!column.hover && !column.chip ? column.hover(row) : null}}" matTooltipPosition="above">
        <ng-container *ngIf="!column.chip">
          <a *ngIf="!!column.linkTransformer && !column.valueCallback" [routerLink]="column.linkTransformer(getRowValue(row, column))" validatedIconrouterLink="active">{{getRowValue(row, column)}}</a>
          <div *ngIf="!column.linkTransformer && !column.valueCallback" [ngClass]="{'column-text': bigTable}" class="column-content">
            <ng-container *ngIf="column.icon && (!column.validate || row.isValidated)"><i class="material-icons">{{column.icon}}</i>
            </ng-container>
            <ng-container *ngIf="!column.icon">
              <span *ngIf="bigTable" matTooltip="{{getRowValue(row, column)}}">{{getRowValue(row, column)}}</span>
              <span *ngIf="!bigTable" [innerHTML]="getRowValue(row, column)"></span>
            </ng-container>
          </div>
          <div *ngIf="!!column.valueCallback && !column.linkTransformer" class="column-content">
            <span [innerHTML]="column.valueCallback(row, column.additionalData)"></span>
          </div>
        </ng-container>
        <div *ngIf="!!column.chip" class="chip-list" matTooltip="{{!!column.hover ? column.hover(row) : null}}" matTooltipPosition="right">
          <div class="chip {{column?.valueCallback ? column?.valueCallback(row, column.additionalData) : null}}"></div>
        </div>
      </div>
      <div class="column actions">
        <button (click)="onCustom(skip + index, row, $event)" *ngIf="showCustom" mat-icon-button>
          <mat-icon *ngIf="!row.isValidated">{{icon}}</mat-icon>
          <mat-icon *ngIf="row.isValidated">{{alternative_icon}}</mat-icon>
        </button>
        <button (click)="onRemove(skip + index, row, $event)" *ngIf="showRemove" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
        <button (click)="onEdit(skip + index, row, $event)" *ngIf="showEdit" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button (click)="onDetail(skip + index, row, $event)" *ngIf="showDetail" mat-icon-button>
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        <mat-checkbox (change)="onSelect(skip + index, row, $event)" *ngIf="selectable" [checked]="selectedIdList.includes(skip + index)"></mat-checkbox>
      </div>
    </div>
  </div>

  <div *ngIf="total && !noFooter" class="table-footer">
    <div class="left">
      <div class="item-count">Total {{total}} {{'general.dataTableItems' | translate}}</div>
      <button (click)="resetFilters()" mat-button>{{'general.resetDataTable' | translate}}
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <div class="right">
      <span class="select-label">{{'general.itemsPerPage' | translate}}</span>
      <mat-select (selectionChange)="perPageChange($event)" [(value)]="limit">
        <mat-option [value]="10">
          10
        </mat-option>
        <mat-option [value]="20">
          20
        </mat-option>
        <mat-option [value]="total">
          {{'general.all' | translate}}
        </mat-option>
      </mat-select>

      <button (click)="onNavigateToFirstPage()" [disabled]="navigation.isFirst" mat-icon-button>
        <mat-icon>first_page</mat-icon>
      </button>
      <button (click)="onNavigateBackwards()" [disabled]="navigation.isFirst" mat-icon-button>
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button (click)="onNavigateForwards()" [disabled]="navigation.isLast" mat-icon-button>
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button (click)="onNavigateToLastPage()" [disabled]="navigation.isLast" mat-icon-button>
        <mat-icon>last_page</mat-icon>
      </button>
    </div>
  </div>
</mat-card>
